import React, { FC, ReactNode, useMemo } from 'react';
import { ApiResponse, Conversation, CustomerRelations, EmailMessageModel, MessageIntegrationEvent } from '../models/typings';
import ActivityService from '../services/activityService';

export interface IActivityService {
  getConversationsByQueryString(queryString: string): Promise<ApiResponse<Conversation>>;
  getConversationHistoryByConversationId(conversationId: string): Promise<MessageIntegrationEvent[]>;
  getCustomerRelatedEntities(customerId: string): Promise<CustomerRelations>
  getEmailsByConversationId(conversationId: string): Promise<EmailMessageModel[]>;
}

interface IProps {
  token: string;
  apiBaseUrl: string;
  children: ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const ActivityServiceContext = React.createContext<IActivityService>(undefined!);

const ActivityServiceProvider: FC<IProps> = (props) => {
  const { token, apiBaseUrl, children } = props;

  const service = useMemo(
    () => new ActivityService(token, apiBaseUrl),
    [apiBaseUrl, token],
  );

  return (
    <ActivityServiceContext.Provider value={service}>
      {children}
    </ActivityServiceContext.Provider>
  );
};

export default ActivityServiceProvider;